import { useLocation, useSearchParams } from "react-router-dom";

/**
 * Returns true when individual prefill APIs should be skipped on the visit
 * note page during initial encounter creation. Skips while the URL carries
 * `hasEncounterCreation=true`; flips off once the snapshot returns existing
 * data and PatientEncounter rewrites the param to `false`.
 */
export const useEncounterCreationGate = (): boolean => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const isVisitNotePage = pathname.includes("/visit-note");
  const hasEncounterCreation =
    searchParams.get("hasEncounterCreation") === "true";

  return isVisitNotePage && hasEncounterCreation;
};
